import { IContentResponseApi, IResponseApi } from '@/interfaces';
import { UseMutateAsyncFunction } from '@tanstack/react-query';
import { ColDef } from 'ag-grid-community';
import { AgGridReactProps } from 'ag-grid-react';
import * as Yup from 'yup';
export interface IStatisticsTablePops extends AgGridReactProps {
  param?: object;
  validator?: Yup.SchemaOf<object>;
  mutateAsync: UseMutateAsyncFunction<IContentResponseApi, IResponseApi, object>;
  columnDefs: Array<ColDef>;
}

export enum StatisticsEnum {
  STATISTIC_AGENT_POINT = 'StatisticAgentPoint',
  STATISTIC_DAILY = 'StatisticDaily',
  STATISTIC_POINT_BY_VENDOR = 'StatisticPointByVendor',
  STATISTIC_LIST_GAME_TYPE = 'StatisticListGameType',
  STATISTIC_POINT_BY_VENDOR_CHERT_COMPANY = 'StatisticPointByVendorChartCompany',
  STATISTIC_POINT_BY_VENDOR_CHERT_AGENT = 'StatisticPointByVendorChartAgent',
  STATISTIC_LIST_BY_PARENT = 'AuthServiceAgentsListByParent',
  STATISTIC_LIST_BY_PARENT_CHILDREN = 'useStatisticAgentPointByParenChildren',
  STATISTIC_LIST_AGENT_POINT_CHILDREN = 'useStatisticAgentPointChildren',
  URL_STATISTIC_DAILY_GAME_PROVIDER_LIST = 'adapterServiceGameProviderList',
  URL_STATISTIC_DAILY_AGENT_LIST = 'transServiceAgentList',
  STATISTIC_LIST_VENDOR = 'StatisticListVendor',
}

export interface IStatisticAgentPointParam {
  page_no?: number;
  page_size?: number;
  parent_id?: string;
  agent_id?: string;
  from_date?: string;
  to_date?: string;
}

export interface IChartType {
  label: string;
  data: Array<number>;
  backgroundColor: string;
}
export interface IChartData {
  labels: Array<string>;
  datasets: Array<IChartType>;
}
export interface IStatisticAgentPointChildrenParam {
  parent_id: string;
}
export interface IStatisticDailyParam {
  startDate?: string;
  endDate?: string;
  agentId?: string;
  vendorId?: string;
  page_no?: number;
  page_size?: number;
  sort?: string;
  getChildren?: boolean;
}

export interface IKeyType {
  [key: string]: number | string;
}
export interface IStatisticAgentPointParam {
  limit?: number;
  page?: number;
}

export interface IStatisticAgentPointListByParentResponse {
  agent_id: string;
  agent_name: string;
}

export interface IStatisticAgentPointListByVendorResponse {
  content: IStatisticAgentPointListByVendorContentItem[];
  empty: boolean;
  first: boolean;
  last: boolean;
  number: number;
  numberOfElements: number;
  totalElements: number;
  totalPages: number;
}

export interface IStatisticAgentPointListByVendorContentItem {
  vendor: string|null;
  parentAgent?: string;
  agent?: string;
  profit?: number;
  profitVendor: number|null;
  bettingAmount?: number;
  bettingAmountVendor: number|null;
  winAmount?: number;
  winAmountVendor: number|null;
  cancelAmount?: number;
  cancelAmountVendor: number|null;
}

export interface IStatisticAgentByVendorChartResponse {
  totalBetting?: number;
  totalCancel?: number;
  totalProfit?: number;
  totalWin?: number;
}

export interface IStatisticAgentByVendorChartDataResponse {
  Month: IStatisticAgentByVendorChartResponse;
  Last_month: IStatisticAgentByVendorChartResponse;
  Today: IStatisticAgentByVendorChartResponse;
  Last_Day: IStatisticAgentByVendorChartResponse;
  Last_Week: IStatisticAgentByVendorChartResponse;
  Week: IStatisticAgentByVendorChartResponse;
}

export interface IStatisticDailyGameProviderListResponse {
  id: string;
  providerName: string;
}

export interface IStatisticDailyAgentListListResponse {
  agentId: string;
  agentName: string;
}

export interface IStatisticAgentPointResponse extends IStatisticAgentPointListByParentResponse {
  revenue: number;
  bet: number;
  win: number;
  cancel: number;
  ma_id: string;
  parent_name: string;
  agent_point_balance: number;
  agent_point_rate: number;
  ma_point_balance: number;
  ma_point_rate: number;
  rate_diff: number;
}
export interface IStatisticDailyResponse {
  agentPoint: number;
  agentPointRate: number;
  betAmount: number;
  cancelAmount: number;
  chargeAmount: number;
  dateReport: string;
  holdingPoints: number;
  maPointRate: number;
  rateDiff: number;
  revenue: number;
  winAmount: number;
}

export type IStatisticVendorParamColumn = {
  vendorId?: string;
  gameType?: string[];
  agentId: string;
};

export interface IStatisticGameTableParam {
  startDate?: string;
  endDate?: string;
  agentId?: string;
  vendorId?: string;
  userId?: string;
  page_no?: number;
  page_size?: number;
  sort?: string;
  getChildren?: boolean;
  filter?: string;
}

export interface IStatisticGameTableResponse {
  vendor: string;
  gameName: string;
  betAmount: number;
  winAmount: number;
  cancelAmount: number;
  ggr: number;
}